var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 40,
    viewBox: "0 0 54 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 0H34.6667H32C25 0 28.6 0 25.6667 0L22.6667 1.84377e-05C19.7333 1.84377e-05 25.1236 1.20799e-05 21.3333 3.33786e-06L18.6667 0H5.33334C2.4 0 0 2.4 0 5.33334V34.6667C0 37.6 2.4 40 5.33334 40H48C50.9334 40 53.3334 37.6 53.3334 34.6667V5.33334C53.3334 2.4 50.9334 0 48 0ZM18.6667 13.3333C20.88 13.3333 22.6667 15.12 22.6667 17.3333C22.6667 19.5467 20.88 21.3333 18.6667 21.3333C16.4533 21.3333 14.6667 19.5467 14.6667 17.3333C14.6667 15.12 16.4533 13.3333 18.6667 13.3333ZM26.6667 29.3333H10.6667V27.3333C10.6667 24.6667 16 23.3333 18.6667 23.3333C21.3333 23.3333 26.6667 24.6667 26.6667 27.3333V29.3333ZM42.6667 25.3333H32V21.3333H42.6667V25.3333ZM42.6667 17.3333H32V13.3333H42.6667V17.3333Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDf);
export default __webpack_public_path__ + "static/media/df.5264799b04f7b494b075ae4c905824ff.svg";
export { ForwardRef as ReactComponent };